import { Environment, EnvironmentConfig } from "./types";

const viteEnv = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

/**
 * Environment configurations
 */
const configs: Record<Environment, EnvironmentConfig> = {
  [Environment.DEV_LOCAL]: {
    apiBaseUrl: "http://localhost:8092",
    s3BaseUrl: "https://sploot-media.s3.ap-south-1.amazonaws.com",
    webBaseUrl: "http://localhost:5173",
  },
  [Environment.DEVELOPMENT]: {
    apiBaseUrl: "http://localhost:8092",
    s3BaseUrl: "https://sploot-media.s3.ap-south-1.amazonaws.com",
    webBaseUrl: "http://localhost:5173",
  },
  [Environment.STAGING]: {
    apiBaseUrl: "https://api-platform-staging.sploot.space",
    s3BaseUrl: "https://sploot-media.s3.ap-south-1.amazonaws.com",
    webBaseUrl: "https://web-staging-v3.sploot.space",
  },
  [Environment.PRODUCTION]: {
    apiBaseUrl: "https://api-platform.sploot.space",
    s3BaseUrl: "https://sploot-prod-env.s3.ap-south-1.amazonaws.com",
    webBaseUrl: "https://sploot.space",
  },
};

/**
 * Determine the current environment
 * This is set at build time by the Docker build process or Vite CLI
 */
function getCurrentEnvironment(): Environment {
  // VITE_ENVIRONMENT_NAME is set during build via the Dockerfile ARG
  const envName = viteEnv.VITE_ENVIRONMENT_NAME as Environment;

  if (Object.values(Environment).includes(envName)) {
    return envName;
  }

  // If environment name is not valid, use a strict approach
  throw new Error(
    `Invalid environment: ${envName}. Please check build configuration.`,
  );
}

/**
 * Current environment name - determined at build time
 */
export const currentEnvironment = getCurrentEnvironment();

/**
 * Current environment configuration
 */
export const config: EnvironmentConfig = configs[currentEnvironment];
